module.exports = __webpack_public_path__ + "img/help.77d632ec.svg";